// Banner aspect ratios — shared between the admin BannersManager (crop modal
// + preview tile) and the customer-facing Home page carousel. Keeping the
// mapping in one place ensures the cropped image and the rendered carousel
// stay perfectly aligned.

export const BANNER_ASPECT_OPTIONS = [
  { key: "wide",   label: "عريض (16:9)",      ratio: 16 / 9, aspectCss: "16/9", hint: "بانر سينمائي عريض" },
  { key: "medium", label: "متوسط (4:3)",      ratio: 4 / 3,  aspectCss: "4/3",  hint: "نسبة متوازنة" },
  { key: "square", label: "مربع (1:1)",       ratio: 1,      aspectCss: "1/1",  hint: "مثل صور الإعلانات على فيسبوك / إنستغرام" },
  { key: "tall",   label: "طولاني (4:5)",     ratio: 4 / 5,  aspectCss: "4/5",  hint: "بانر طولي بارز" },
];

export const aspectInfo = (key) =>
  BANNER_ASPECT_OPTIONS.find((o) => o.key === key) || BANNER_ASPECT_OPTIONS[0];
